export default {
    components: {
        carat: "Carat",
        shape: "Shape",
        cut: "Cut",
        color: "Color",
        clarity: "Clarity",
        noSelection: "No Selection",
        gia: `All our diamonds are guaranteed by the Gemological
        Institute of America. Click
        <a target="_blank" rel="noopener noreferrer" href="{url}">here</a> for the certificate
        for your selected diamond.`,
        gia2: `<a target="_blank" rel="noopener noreferrer" href="{url}">Link to certificate</a>`,
        ct: "ct",
        yourSelection: "Your Selection",
        ringband: "Ringband",
        price: "Price",
        total: "Total",
        highlighted: "Special Offer",
        noImageHeading: "No image available",
        noImageParagraph: "Sadly your selected diamond has no image available.",
        selectDiamondHeading: "Choose a diamond",
        selectDiamondParagraph:
            "Choose a Diamond with the Diamond Finder to display detailed information here.",
        buyButtonLabel: "Add to cart",
    },
    singleDiamondsConfigurator: {
        heading: "Diamond Finder",
        compareHeading: "In Comparison",
        clarityDiagramHeading: "Clarity Scale",
        colorDiagramHeading: "Color Scale",
        comparableDiamonds: {
            currentHeading: "Current Selection",
            moreCarat: "More Carat",
            betterColor: "Better Color",
            higherClarity: "Higher Clarity",
        },
        priceLabel: "Your selection",
    },
    diamondProperties: {
        shape: {
            AS: "Asscher",
            BAG: "Baguette",
            CB: "Cushion Brilliant",
            CU: "Cushion",
            EM: "Emerald",
            HS: "Heart",
            MQ: "Marquise",
            OV: "Oval",
            PR: "Princess",
            PS: "Pear",
            RA: "Radiant",
            RD: "Brilliant",
            TRIL: "Trilliant",
        },
        color: {
            D: "Very Fine White +",
            E: "Very Fine White",
            F: "Fine White +",
            G: "Fine White",
            H: "White",
            I: "Slightly Tinted White",
            J: "Slightly Tinted White",
            K: "Tinted White",
            L: "Tinted",
            M: "Tinted",
            N: "Tinted",
        },
        clarity: {
            FL: "Flawless",
            IF: "Internally Flawless",
            VVS1: "Very, Very Small Inclusions",
            VVS2: "Very, Very Small Inclusions",
            VS1: "Very Small Inclusions",
            VS2: "Very Small Inclusions",
            SI1: "Small Inclusions",
            SI2: "Small Inclusions",
            I1: "Inclusions",
            I2: "Inclusions",
            I3: "Inclusions",
        },
        cut: {
            EX: "Excellent",
            F: "Fair",
            G: "Good",
            GD: "Good",
            ID: "Ideal",
            P: "Poor",
            VG: "Very Good",
        },
        polish: {
            EX: "Excellent",
            EXCELLENT: "Excellent",
            F: "Fair",
            G: "Good",
            GD: "Good",
            GOOD: "Good",
            "VERY GOOD": "Very Good",
            VG: "Very Good",
        },
        symmetry: {
            EX: "Excellent",
            EXCELLENT: "Excellent",
            F: "Fair",
            FAIR: "Fair",
            G: "Good",
            GD: "Good",
            GOOD: "Good",
            "VERY GOOD": "Very Good",
            VG: "Very Good",
        },
        fluorescence: {
            Faint: "Faint",
            FNT: "Faint",
            MDBLUE: "Medium Blue",
            MED: "Medium",
            Medium: "Medium",
            NON: "None",
            None: "None",
            STG: "Strong",
            Strong: "Strong",
            "Very Slight": "Very Slight",
            VST: "Very Slight",
        },
    },
    diagrams: {
        colorLink:
            "https://cdn.shopify.com/s/files/1/0348/7101/7603/files/Diamond_Color_en.png?v=1694590874",
        clarityLink:
            "https://cdn.shopify.com/s/files/1/0348/7101/7603/files/Diamond_Clarity_en.png?v=1694590856",
    },
    "stockAvailable": "Available immediately.",
    "stockLow": "Only a few items left.",
    "noStock": "Sold out.",
    "defaultDeliveryText": "Ready for shipping in 1 - 2 business days.",
    "customDeliveryText": "Ready for shipping in {time} {unit}.",
    "deliveryUnitDays": "business days",
    "deliveryUnitWeeks": "weeks",
};
